import React, { useState } from 'react';
// CSS
import styles from './CommentsPopup.module.css';
// Components
import Button from '../Button/Button';
import FloatingLabelTextArea from '../Form/FloatingLabelTextArea/FloatingLabelTextArea';
import CommentItem from './CommentItem';

import {useAppSelector, useAppDispatch} from "../../../Redux/Store/Store";
import {selectRolePermissions, createComment, editComment, deleteComment} from "../../../Redux/Store/Slices/questionnaire";

type CommentsPopupProps = {
    contextId?: string;
    authorizationContextId?: string;
};

export type Comment = {
    id: string;
    DateMade: Date;
    CommentText: string;
    Commenter: string;
    Editable: boolean;
    ProgressStatus?: "Not Met" | "Partially Met" | "Met" | "Exceeded";
};

const CommentsPopup = ({ contextId, authorizationContextId }: CommentsPopupProps) => {

    const dispatch = useAppDispatch();
    const [commentText, setCommentText] = useState<string>('');

    const rolePermissions = useAppSelector(selectRolePermissions());
    const { comments, commentsLoading } = useAppSelector(state => state.questionnaire);

    const handleCreateComment = async () => {
        if (commentText.trim() && contextId && authorizationContextId) {
            dispatch(createComment({ criteriaId: contextId, authorizationContextId, commentText }));
            setCommentText(''); // Clear the textarea after saving
        }
    }

    const handleEditComment = async (commentId: string, text: string) => {
        dispatch(editComment({ commentId, text }));
    }

    const handleDeleteComment = async (commentId: string) => {
        dispatch(deleteComment(commentId));
    }


  return (
    <div className={styles.container}>
      {/* Comment Input Area */}
      <div className={styles.inputSection}>
        <FloatingLabelTextArea 
          label="Add your comment..." 
          value={commentText} 
          onChange={(value) => setCommentText(value)}
        />
        <Button 
          type="button" 
          clickHandler={handleCreateComment}
          className={styles.sendButton}
        >
          Send
        </Button>
      </div>

      {/* Existing comments */}
      <div className={styles.commentsList}>
        {comments.map(comment => (
          <CommentItem 
            key={comment.id} 
            comment={comment}
            onEdit={handleEditComment}
            onDelete={handleDeleteComment}
            canEdit={true}
            canDelete={true}
          />
        ))}
      </div>
    </div>
  );
};

export default CommentsPopup;
